/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { ButtonGroup, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Table } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllPromotionalOfferList } from "../../redux/Slice/PromotionalOffer/PromotionalOffersListSlice";
import { toast } from "react-toastify";

const ListOfPromotioanlOffers = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { AllPromotionalOfferData , errorMessage } = useAppSelector(
    (state) => state.promotionalOffer
  );

  useEffect(() => {
    dispatch(AllPromotionalOfferList());
  }, []);

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const ListHeader = ["Sr No", "Event Name", "Sport Name", "Created At", "Start Date", "End Date", "Start Time", "End Time", "Discount %", "Status",]
  const ListAccessor = ["srNo", "name", "sportName", "createdAt", "startDate", "endDate", "startTime", "endTime", "discountPercent", "status",]
  const columns = React.useMemo(
    () => ListHeader.map((item, index) => (
      {
        Header: item,
        accessor: ListAccessor[index],
      }
    )), []);

  const handleAdd = () => {
    navigate("/create-update-discount-offer", { state: { for: "Create" } });
  };

  const handleEdit = (id: string) => {
    navigate("/create-update-discount-offer", {
      state: { id: id, for: "Update" },
    });
  };

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">List of Discount Offers</Card.Title>
            <ButtonGroup>
              <Button
                onClick={handleAdd}
                type="button"
                bname="Create Offers"
                name="add-offer"
                id="add-offer"
                className="btn btn-primary rounded-1"
              ></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table
          columns={columns}
          data={AllPromotionalOfferData}
          handleEdit={handleEdit}
          hideViewAction={true}
          hideDeleteAction={true}
        />
      </Card>
    </>
  );
};

export { ListOfPromotioanlOffers };
